import React from "react";
import { Row, Col, Button } from "antd";

const QRSection = (props) => {
    return (
        <div id="ctapage">
            <Row gutter={[16, 16]}>
                <Col xs={0} md={4} />
                <Col xs={24} md={16}>
                    <div className="ctapagecontent" style={{textAlign:'center'}}>
                        <h1 style={{ textAlign: 'center', color: '#fff', fontWeight: 'bold' }}>How India Shops Online 2026 Report is Out Now!</h1>
                        <p style={{ textAlign: 'center' }}>The future of e-retail is unfolding now</p>
                        {/* <p style={{ textAlign: 'center' }}>Explore the trends driving India’s next phase of e-retail growth</p> */}
                        <img src="/img/hisqr.png" alt="HISO QR Code" style={{ display: 'block', margin: '20px auto', borderRadius: '10px', width: '200px', height: '200px' }} />
                        <p style={{ textAlign: 'center' }}>Explore the trends driving India’s next phase of e-retail growth<br />

                            Scan the QR or click below to download the full report.</p>
                        <Button type="primary" target="_blank" href="https://drive.google.com/file/d/1F5DPqrqOimhzCsyvUIs_hgPZdlX21Se8/view?usp=drivesdk">Download Report</Button>
                    </div>
                    {/* <div style={{textAlign:'center'}}>
                        <Button className="meetjurybtn" type="primary" target="_blank" href="/jury">Know More</Button>
                    </div> */}
                </Col>
                <Col xs={0} md={4} />

            </Row>
        </div>
    );
};

export default QRSection;
